import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class gpcGoogleService {
  //private apiUrl = 'http://localhost:3000/api/image-url';
    private apiUrl =  `${environment.apiUrl}/api/image-url`; 
    private apiUrls =  `${environment.apiUrl}/api/files-url`; 
    private apiListFilesByPath = `${environment.apiUrl}/api/list-files-by-path`;

  // 🔹 Cache de imágenes base64 por URL
  private base64Cache = new Map<string, string>();

  constructor(private http: HttpClient) {}

  /** Obtener URL firmada desde el backend */
  getSignedUrl(filePath: string): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${this.apiUrl}/${filePath}`);
  }

  /** Obtener URL de archivo desde el backend */
 getSignedUrlFiles(filePath: string): Observable<{ success: boolean; url: string }> {
  return this.http.get<{ success: boolean; url: string }>(
     `${this.apiUrls}/${filePath}`
  );
}

  /** Obtener imagen como Blob directamente desde el backend */
  getImage(folder: string, fileName: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/image/${folder}/${fileName}`, {
      responseType: 'blob',
    });
  }

  /**
   * Obtener imagen en base64 desde URL con caché
   * @param imageUrl URL firmada o pública
   */
  async getImageBase64(imageUrl: string): Promise<string> {
    if (this.base64Cache.has(imageUrl)) {
      return this.base64Cache.get(imageUrl)!;
    }

    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error(`Error al obtener imagen: ${response.statusText}`);
      }

      const blob = await response.blob();
      const base64 = await this.blobToBase64(blob);

      this.base64Cache.set(imageUrl, base64); // 🔒 Guardar en caché
      return base64;
    } catch (error) {
      console.error('Error en getImageBase64:', error);
      throw error;
    }
  }

  /** Convertir Blob a base64 */
  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  /** Limpiar caché manualmente si es necesario */
  clearCache(): void {
    this.base64Cache.clear();
  }

listFiles(nit: string,nitBase:number) {
  const baseApi = this.apiUrl.replace('/image-url', '');
  return this.http.get<any[]>(`${baseApi}/list-files/${nit}/${nitBase}`);
}


listFilesLicencia( cedula: string,nit:number) {
  const baseApi = this.apiUrl.replace('/image-url', '');
  //console.log(`${baseApi}/list-files-licencia/${cedula}/${nit}`);
  return this.http.get<any[]>(`${baseApi}/list-files-licencia/${cedula}/${nit}`);
}


//LISTADO DE ARCHIVOS 
listarArchivosPorRuta(ruta: string): Observable<any> {
  return this.http.get<any>(
    `${this.apiListFilesByPath}/${ruta}`
  );
}

}
